import {
  Building2Icon,
  PiggyBankIcon,
  ReceiptTextIcon,
  ShieldCheckIcon,
  SunsetIcon,
  UsersIcon,
  type LucideIcon,
} from "lucide-react";

export type Need = {
  id: string;
  title: string;
  lead: string;
  body: string;
  icon: LucideIcon;
};

export const needs: Need[] = [
  {
    id: "immobilier",
    title: "Investir dans l'immobilier",
    lead: "La pierre, rentable quand elle est bien organisée.",
    body: "Investir dans la pierre peut s'avérer très rentable à condition de s'impliquer dans l'organisation, d'optimiser son financement et sa fiscalité.",
    icon: Building2Icon,
  },
  {
    id: "placer",
    title: "Placer son argent",
    lead: "Une stratégie financière adaptée à votre profil.",
    body: "Nos conseillers en patrimoine vous proposent les meilleures solutions pour placer votre argent avec une stratégie financière adaptée.",
    icon: PiggyBankIcon,
  },
  {
    id: "impots",
    title: "Payer moins d'impôts",
    lead: "Vous souhaitez diminuer votre fiscalité ?",
    body: "Pour défiscaliser, à savoir réduire le montant de ses impôts, il est important d'établir une stratégie pour optimiser sa fiscalité à long terme.",
    icon: ReceiptTextIcon,
  },
  {
    id: "garantie",
    title: "Garantie de passif",
    lead: "Sécuriser la vente de votre entreprise.",
    body: "La garantie actif-passif protège l'acheteur contre toute détérioration de la valeur des actifs ou toute augmentation imprévue des passifs après l'acquisition. Une sécurité financière et juridique essentielle lors d'une cession.",
    icon: ShieldCheckIcon,
  },
  {
    id: "retraite",
    title: "Préparer sa retraite",
    lead: "Il n'y a pas d'âge pour y penser.",
    body: "Au vu de la conjoncture économique incertaine, anticiper sa retraite en amont est devenu indispensable.",
    icon: SunsetIcon,
  },
  {
    id: "famille",
    title: "Protéger sa famille",
    lead: "Transmission, donation, prévoyance.",
    body: "Optimiser ses placements pour prévoir le futur. Si l'idée de prévoyance prend un sens tout particulier à l'arrivée de son premier enfant, les conjoints sont également concernés.",
    icon: UsersIcon,
  },
];
